import React, { useState, useEffect } from "react";
import { FaCircle } from "react-icons/fa";
import Content from "../../../ExtraComponent/Content";
import { subadminDashboard, subadminDashboardTrade } from "../../CommonAPI/SubAdmin";

const Dashboards = () => {
  const userName = localStorage.getItem("name");

  const [Data3, setData3] = useState({ loading: true, data3: [] });
  const [Data4, setData4] = useState({ loading: true, data4: [] });

  const getOneMonthAgoDate = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date.toISOString().split("T")[0];
  };
  const getNextDate = () => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date.toISOString().split("T")[0];
  };

  const [fromDate, setFromDate] = useState(getOneMonthAgoDate());
  const [toDate, setToDate] = useState(getNextDate());
  const [fromDate1, setFromDate1] = useState(getOneMonthAgoDate());
  const [toDate1, setToDate1] = useState(getNextDate());

  const formatDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${year}.${month}.${day}`;
  };

  const fetchSubAdminDashboard = async () => {
    try {
      setData3({ ...Data3, loading: true });
      const response = await subadminDashboard({
        From_date: formatDate(fromDate),
        To_date: formatDate(toDate),
        Subadminname: userName,
      });
      setData3({ loading: false, data3: response?.Status ? response.Data : [] });
    } catch (err) {
      console.error(err);
      setData3({ loading: false, data3: [] });
    }
  };

  const subadminDashboardTradeApi = async () => {
    try {
      setData4({ ...Data4, loading: true });
      const response = await subadminDashboardTrade({
        From_date: formatDate(fromDate1),
        To_date: formatDate(toDate1),
        Subadminname: userName,
      });
      setData4({ loading: false, data4: response?.Status ? response.Data : [] });
    } catch (err) {
      console.error(err);
      setData4({ loading: false, data4: [] });
    }
  };

  useEffect(() => { fetchSubAdminDashboard(); }, [fromDate, toDate]);
  useEffect(() => { subadminDashboardTradeApi(); }, [fromDate1, toDate1]);

  // Status color helper
  const renderStatus = (status) => {
    const colors = { online: "text-success", blue: "text-primary", away: "text-warning", primary: "text-info" };
    return <FaCircle className={`${colors[status]} me-2`} />;
  };

  // Account cards with all fields intact
  const accountCards = [
    {
      title: "Live Account",
      data: Data3?.data3[0],
      fields: [
        { label: "Total", value: "Total_Live_Account", status: "online" },
        { label: "Active", value: "Active_Live_Account", status: "blue" },
        { label: "Expired", value: "Expired_Live_Account", status: "away" },
      ],
    },
    {
      title: "Free Demo Account",
      data: Data3?.data3[0],
      fields: [
        { label: "Total", value: "Total_Free_Demo_Account", status: "online" },
        { label: "Active", value: "Active_Free_Demo_Account", status: "blue" },
        { label: "Expired", value: "Expired_Free_Demo_Account", status: "away" },
      ],
    },
    {
      title: "Three Days Live Account",
      data: Data3?.data3[0],
      fields: [
        { label: "Total", value: "Total_Two_Days_Live_Account", status: "online" },
        { label: "Active", value: "Active_Two_Days_Live_Account", status: "blue" },
        { label: "Expired", value: "Expired_Two_Days_Live_Account", status: "away" },
      ],
    },
  ];

  // Trade cards with all fields intact
  const tradeCards = [
    {
      title: "Total Trade",
      data: Data4?.data4[0],
      fields: [
        { label: "Scalping", value: "ScalpingTotalTrade", status: "blue" },
        { label: "Option", value: "OptionTotalTrade", status: "blue" },
        { label: "Pattern", value: "PatternTotalTrade", status: "primary" },
        { label: "Charting", value: "ChartingTotalTrade", status: "primary" },
      ],
    },
    {
      title: "Paper Trade",
      data: Data4?.data4[0],
      fields: [
        { label: "Scalping", value: "ScalpingPaperTrade", status: "blue" },
        { label: "Option", value: "OptionPaperTrade", status: "blue" },
        { label: "Pattern", value: "PatternPaperTrade", status: "primary" },
        { label: "Charting", value: "ChartingPaperTrade", status: "primary" },
      ],
    },
    {
      title: "Live Trade",
      data: Data4?.data4[0],
      fields: [
        { label: "Scalping", value: "ScalpingLiveTrade", status: "blue" },
        { label: "Option", value: "OptionLiveTrade", status: "blue" },
        { label: "Pattern", value: "PatternLiveTrade", status: "primary" },
        { label: "Charting", value: "ChartingLiveTrade", status: "primary" },
      ],
    },
  ];

  return (
    <Content Page_title="📈 Dashboard" button_status={false} backbutton_status={false}>
        <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item active " aria-current="page">
           Dashboard
          </li>
        </ol>
      </nav>
      <div className="container-fluid py-4">

        {/* Filter Accounts */}
        <div className="mb-3 card-bg-color themed-card d-flex justify-content-start align-items-center flex-wrap align-items-start gap-3  card-text-Color">
          <strong>Filter Accounts:</strong>
          <div className="d-flex align-items-center gap-2">
            <label htmlFor="fromDate" className="form-label mb-0">From</label>
            <input type="date" id="fromDate" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
          </div>
          <div className="d-flex align-items-center gap-2">
            <label htmlFor="toDate" className="form-label mb-0">To</label>
            <input type="date" id="toDate" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
          </div>
        </div>

        {/* Account Cards */}
        <div className="row">
          {accountCards.map((card, idx) => (
            <div className="col-lg-4 mb-4" key={idx}>
              <div className="card-text-Color card-bg-color">
                <h5 className="fw-bold mb-3">{card.title}</h5>
                <ul className="list-unstyled mb-0">
                  {card.fields.map((field, i) => (
                    <li key={i} className="d-flex align-items-center mb-2">
                      {renderStatus(field.status)}
                      <span className="flex-grow-1">{field.label}:</span>
                      <span className="fw-bold">{card.data?.[field.value]}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Filter Trades */}
        <div className="mb-3  card-bg-color themed-card d-flex justify-content-start align-items-center flex-wrap align-items-start gap-3  card-text-Color">
          <strong>Filter Trades:</strong>
          <div className="d-flex align-items-center gap-2">
            <label htmlFor="fromDate1" className="form-label mb-0">From</label>
            <input type="date" id="fromDate1" className="form-control" value={fromDate1} onChange={(e) => setFromDate1(e.target.value)} />
          </div>
          <div className="d-flex align-items-center gap-2">
            <label htmlFor="toDate1" className="form-label mb-0">To</label>
            <input type="date" id="toDate1" className="form-control" value={toDate1} onChange={(e) => setToDate1(e.target.value)} />
          </div>
        </div>

        {/* Trade Cards */}
        <div className="row">
          {tradeCards.map((card, idx) => (
            <div className="col-lg-4 mb-4" key={idx}>
              <div className="card-text-Color card-bg-color">
                <h5 className="fw-bold mb-3">{card.title}</h5>
                <ul className="list-unstyled mb-0">
                  {card.fields.map((field, i) => (
                    <li key={i} className="d-flex align-items-center mb-2">
                      {renderStatus(field.status)}
                      <span className="flex-grow-1">{field.label}:</span>
                      <span className="fw-bold">{card.data?.[field.value]}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

      </div>
    </Content>
  );
};

export default Dashboards;
